import { render, staticRenderFns } from "./FlowConfig01FlowList.vue?vue&type=template&id=85fa5178&scoped=true&"
import script from "./FlowConfig01FlowList.vue?vue&type=script&lang=js&"
export * from "./FlowConfig01FlowList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fa5178",
  null
  
)

export default component.exports